// import {
//   Box,
//   Checkbox,
//   FormControl,
//   FormControlLabel,
//   FormGroup,
//   Grid,
//   InputLabel,
//   OutlinedInput,
//   Select,
//   Skeleton,
// } from '@mui/material'
// import {DataGrid} from '@mui/x-data-grid'
// import React, {useEffect, useState} from 'react'
// import {useGetItemCodeQuery} from '../../store/api/itemCodeApi'

// const ItemCode = ({itemCode, setItemCode, businessUnitId}) => {
//     const {data: itemCodeData, isLoading} = useGetItemCodeQuery(businessUnitId)
//     const [checked, setChecked] = useState(true)
//     const [disabled, setDisabled] = useState(true)
//     const [tableData, setTableData] = useState([])


//     useEffect(() => {
//         if (!isLoading) {
//             setTableData(itemCodeData?.data)
//         }
//     }, [isLoading, itemCodeData])

//     const handleCheckChange = (event) => {
//         const isChecked = event.target.checked
//         setChecked(isChecked)
//         setDisabled(isChecked)
//         if (isChecked) {
//             setItemCode([])
//         }
//     }

//     return (
//         <Grid container spacing={1}>
//             <Grid item xs={9}>
//                 {isLoading ? (
//                     <Skeleton variant="rectangular" height={35}/>
//                 ) : (
//                     <FormControl fullWidth size="small">
//                         <InputLabel>Item Code</InputLabel>
//                         <Select
//                             multiple
//                             value={itemCode}
//                             input={<OutlinedInput label="Item Code"/>}
//                             disabled={disabled}
//                             sx={{padding: 0}}
//                             renderValue={(selected) => {
//                                 if (selected.includes([])) {
//                                     return 'All'
//                                 }
//                                 selected.map((x) => itemCodeData?.data.find((y) => y.item_Code === x)?.description).join(', ')
//                             }}
//                         >
//                             <Box sx={{height: 250, width: 450, padding: 0}}>
//                                 <DataGrid
//                                     sx={{padding: 0}}
//                                     onSelectionModelChange={(newSelectionModel) => {
//                                         setItemCode(newSelectionModel.map((id) => tableData.find((row) => getRowId(row) === id)?.item_Code))
//                                     }}
//                                     getRowId={getRowId}
//                                     checkboxSelection
//                                     rows={tableData || []}
//                                     columns={columns}
//                                     autoHeight
//                                     disableSelectionOnClick
//                                     experimentalFeatures={{newEditingApi: true}}
//                                     hideFooter
//                                 />
//                             </Box>
//                         </Select>
//                     </FormControl>
//                 )}
//             </Grid>
//             <Grid item xs={3}>
//                 <FormGroup>
//                     <FormControlLabel control={<Checkbox checked={checked} onChange={handleCheckChange}/>} label="All"/>
//                 </FormGroup>
//             </Grid>
//         </Grid>
//     )
// }

// export default ItemCode

// const columns = [
//     {
//         field: 'item_Code',
//         headerName: 'Item Code',
//     },
//     {
//         field: 'description',
//         headerName: 'Description',
//         width: 300,
//     },
// ]


// function getRowId(row) {
//     return row.item_Code + row.description
// }


import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    InputLabel,
    OutlinedInput,
    Select,
    Skeleton,
} from '@mui/material'
import {DataGrid} from '@mui/x-data-grid'
import React, {useEffect, useState} from 'react'
import {useGetItemCodeQuery} from '../../store/api/itemCodeApi'
import PageSelector from './PageSelector'

const ItemCode = ({itemCode, setItemCode, businessUnitId}) => {
    function* paginateData(data, pageSize) {
        let pageIndex = 0
        while (pageIndex * pageSize < data.length) {
            const start = pageIndex * pageSize
            const end = (pageIndex + 1) * pageSize
            yield data.slice(start, end)
            pageIndex++
        }
    }

    const {data: itemCodeData, isLoading} = useGetItemCodeQuery(businessUnitId)
    const [checked, setChecked] = useState(true)
    const [disabled, setDisabled] = useState(true)
    const [tableData, setTableData] = useState([])

    const handleCheckChange = (event) => {
        const isChecked = event.target.checked
        setChecked(isChecked)
        setDisabled(isChecked)
        if (isChecked) {
            setItemCode([])
        }
    }

    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(20)
    const itemCodeGenerator = paginateData(itemCodeData?.data || [], pageSize)

    const paginatedData = []
    for (const page of itemCodeGenerator) {
        paginatedData.push(page)
    }

    useEffect(() => {
        setTableData(paginatedData)
    }, [paginatedData])

    const handleChangePage = (newPage) => {
        setPage(newPage)
    }

    const handleChangePageSize = (newPageSize) => {
        setPageSize(newPageSize)
    }

    return (
        <Grid container spacing={1}>
            <Grid item xs={9}>
                {isLoading ? (
                    <Skeleton variant="rectangular" height={35}/>
                ) : (
                    <FormControl fullWidth size="small">
                        <InputLabel>Item Code</InputLabel>
                        <Select
                            multiple
                            value={itemCode}
                            input={<OutlinedInput label="Item Code"/>}
                            disabled={disabled}
                            sx={{padding: 0, backgroundColor: disabled ? 'hsl(0, 0%, 95%)' : 'white'}}
                            renderValue={(selected) => {
                                if (selected.includes([])) {
                                    return 'All'
                                }
                                selected.map((x) => itemCodeData?.data.find((y) => y.item_Code === x)?.description).join(', ')
                            }}
                        >
                            <Box sx={{height: 250, width: 450, padding: 0}}>
                                <DataGrid
                                    sx={{padding: 0}}
                                    onSelectionModelChange={(newSelectionModel) => {
                                        setItemCode(newSelectionModel.map((id) => tableData.find((row) => getRowId(row) === id)?.item_Code))
                                    }}
                                    getRowId={getRowId}
                                    checkboxSelection
                                    columns={columns}
                                    autoHeight
                                    disableSelectionOnClick
                                    experimentalFeatures={{newEditingApi: true}}
                                    hideFooter
                                    rows={paginatedData[page - 1] || []}
                                    pagination
                                    pageSize={pageSize}
                                    rowCount={tableData.length}
                                    paginationMode="server"
                                    onPageChange={handleChangePage}
                                    onPageSizeChange={handleChangePageSize}
                                    page={page}
                                />
                                <PageSelector
                                    currentPage={page}
                                    totalPages={Math.ceil(itemCodeData?.data.length / pageSize)}
                                    onPageChange={handleChangePage}
                                />
                            </Box>
                        </Select>
                    </FormControl>
                )}
            </Grid>
            <Grid item xs={3}>
                <FormGroup>
                    <FormControlLabel control={<Checkbox checked={checked} onChange={handleCheckChange}/>} label="All"/>
                </FormGroup>
            </Grid>
        </Grid>
    )
}

export default ItemCode

const columns = [
    {
        field: 'item_Code',
        headerName: 'Item Code',
    },
    {
        field: 'description',
        headerName: 'Description',
        width: 300,
    },
]

function getRowId(row) {
    return row.item_Code + row.description
}
  